'use client'

import type { EventProperties } from '@segment/analytics-next'
import isUndefined from 'lodash/isUndefined'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useWindowSize } from 'react-use'
import { useAnalytics } from '../../context/Analytics'
import { sendGa4PageView } from '../../lib/ga4'

export default function useViewPage(
  pageViewEvent: string,
  eventProperties = {} as EventProperties
) {
  const { identify, track, sessionId } = useAnalytics()
  const { width: innerWidth } = useWindowSize()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    if (sessionId && track && identify && searchParams && innerWidth) {
      // Clean up any undefined event properties
      const definedEventProperties = {} as EventProperties
      Object.keys(eventProperties).forEach((key) => {
        if (!isUndefined(eventProperties[key])) {
          definedEventProperties[key] = eventProperties[key]
        }
      })

      // Track the initial page view
      track(pageViewEvent, definedEventProperties)
      sendGa4PageView(pathname)

      const properties = {
        userAgent: window.navigator.userAgent,
        windowSize: innerWidth.toString(),
      }

      identify({
        partnerData: searchParams.toString(),
        properties,
        propertiesJSON: JSON.stringify(properties),
        userDeviceInfo: {
          windowSize: innerWidth,
        },
        sessionId,
        releaseVersion: process.env.RELEASE_VERSION,
        ...definedEventProperties,
      })
    }
  }, [sessionId, track, identify, searchParams, innerWidth, pathname])
}
